import { connect } from 'react-redux';

import ManageCampaigns from './ManageCampaigns';
import { getCampaigns, getCampaign } from '../../selectors/campaigns';
import { discardCampaign } from '../../actions/campaigns';
import { accountWalletChange } from '../../actions/account';

const mapStateToProps = state => ({
  campaigns: getCampaigns(state).map(campaign => getCampaign(state, campaign.transactionHash)),
  address: state.account.address,
  balance: state.account.balance,
  catBalance: state.account.catBalance,
});

const mapDispatchToProps = dispatch => ({
  onDiscardCampaign: (...args) => dispatch(discardCampaign(...args)),
  onWalletChange: () => dispatch(accountWalletChange()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ManageCampaigns);



// WEBPACK FOOTER //
// ./src/containers/campaigns/ManageCampaignsContainer.js